/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CatalogDto,
  Profile,
  ProfileListResponse,
  ProfileResolutionResponse,
  ProfileResponse,
  ProfileTailoringRequest,
  ProfileUpdateRequest,
} from '../models/index';
import {
    CatalogDtoFromJSON,
    CatalogDtoToJSON,
    ProfileFromJSON,
    ProfileToJSON,
    ProfileListResponseFromJSON,
    ProfileListResponseToJSON,
    ProfileResolutionResponseFromJSON,
    ProfileResolutionResponseToJSON,
    ProfileResponseFromJSON,
    ProfileResponseToJSON,
    ProfileTailoringRequestFromJSON,
    ProfileTailoringRequestToJSON,
    ProfileUpdateRequestFromJSON,
    ProfileUpdateRequestToJSON,
} from '../models/index';

export interface AnalyzeDependenciesRequest {
    id: string;
}

export interface CreateProfileRequest {
    profile: Profile;
    sessionId?: string;
}

export interface DeleteProfileRequest {
    id: string;
}

export interface GetAllProfilesRequest {
    page?: string;
    pageSize?: string;
}

export interface GetOrganizationalValuesRequest {
    id: string;
}

export interface GetProfileByIdRequest {
    id: string;
}

export interface GetProfilesByVersionRequest {
    version: string;
    page?: string;
    pageSize?: string;
}

export interface GetResolutionHistoryRequest {
    id: string;
    page?: string;
    pageSize?: string;
}

export interface GetResolvedCatalogRequest {
    id: string;
}

export interface ResolveProfileRequest {
    id: string;
    resolvedBy?: string;
}

export interface SearchProfilesByTitleRequest {
    title: string;
    page?: string;
    pageSize?: string;
}

export interface TailorProfileRequest {
    id: string;
    profileTailoringRequest: ProfileTailoringRequest;
}

export interface UpdateProfileRequest {
    id: string;
    profileUpdateRequest: ProfileUpdateRequest;
}

export interface ValidateProfileRequest {
    id: string;
}

/**
 * ProfileApi - interface
 * 
 * @export
 * @interface ProfileApiInterface
 */
export interface ProfileApiInterface {
    /**
     * Analyze the dependencies and imports of a profile
     * @summary Analyze dependencies
     * @param {string} id Profile UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApiInterface
     */
    analyzeDependenciesRaw(requestParameters: AnalyzeDependenciesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>>;

    /**
     * Analyze the dependencies and imports of a profile
     * Analyze dependencies
     */
    analyzeDependencies(requestParameters: AnalyzeDependenciesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object>;

    /**
     * Create a new OSCAL profile. Ensures the tenant has the default catalog (from configuration service or file) so controls can be rendered.
     * @summary Create profile
     * @param {Profile} profile 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApiInterface
     */
    createProfileRaw(requestParameters: CreateProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileResponse>>;

    /**
     * Create a new OSCAL profile. Ensures the tenant has the default catalog (from configuration service or file) so controls can be rendered.
     * Create profile
     */
    createProfile(requestParameters: CreateProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileResponse>;

    /**
     * Delete an OSCAL profile
     * @summary Delete profile
     * @param {string} id Profile UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApiInterface
     */
    deleteProfileRaw(requestParameters: DeleteProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete an OSCAL profile
     * Delete profile
     */
    deleteProfile(requestParameters: DeleteProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Retrieve a paginated list of all OSCAL profiles
     * @summary Get all profiles
     * @param {string} [page] 
     * @param {string} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApiInterface
     */
    getAllProfilesRaw(requestParameters: GetAllProfilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileListResponse>>;

    /**
     * Retrieve a paginated list of all OSCAL profiles
     * Get all profiles
     */
    getAllProfiles(requestParameters: GetAllProfilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileListResponse>;

    /**
     * Retrieve all organizational values defined for a profile
     * @summary Get organizational values
     * @param {string} id Profile UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApiInterface
     */
    getOrganizationalValuesRaw(requestParameters: GetOrganizationalValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileTailoringRequest>>;

    /**
     * Retrieve all organizational values defined for a profile
     * Get organizational values
     */
    getOrganizationalValues(requestParameters: GetOrganizationalValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileTailoringRequest>;

    /**
     * Retrieve a specific OSCAL profile by its UUID
     * @summary Get profile by ID
     * @param {string} id Profile UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApiInterface
     */
    getProfileByIdRaw(requestParameters: GetProfileByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileResponse>>;

    /**
     * Retrieve a specific OSCAL profile by its UUID
     * Get profile by ID
     */
    getProfileById(requestParameters: GetProfileByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileResponse>;

    /**
     * Retrieve all profiles with a specific version
     * @summary Get profiles by version
     * @param {string} version Profile version
     * @param {string} [page] 
     * @param {string} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApiInterface
     */
    getProfilesByVersionRaw(requestParameters: GetProfilesByVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileListResponse>>;

    /**
     * Retrieve all profiles with a specific version
     * Get profiles by version
     */
    getProfilesByVersion(requestParameters: GetProfilesByVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileListResponse>;

    /**
     * Retrieve the history of profile resolutions
     * @summary Get resolution history
     * @param {string} id Profile UUID
     * @param {string} [page] 
     * @param {string} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApiInterface
     */
    getResolutionHistoryRaw(requestParameters: GetResolutionHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileResolutionResponse>>;

    /**
     * Retrieve the history of profile resolutions
     * Get resolution history
     */
    getResolutionHistory(requestParameters: GetResolutionHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileResolutionResponse>;

    /**
     * Retrieve the resolved catalog for a profile, if it exists
     * @summary Get resolved catalog
     * @param {string} id Profile UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApiInterface
     */
    getResolvedCatalogRaw(requestParameters: GetResolvedCatalogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CatalogDto>>;

    /**
     * Retrieve the resolved catalog for a profile, if it exists
     * Get resolved catalog
     */
    getResolvedCatalog(requestParameters: GetResolvedCatalogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CatalogDto>;

    /**
     * Resolve a profile to generate a tailored catalog
     * @summary Resolve profile
     * @param {string} id Profile UUID
     * @param {string} [resolvedBy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApiInterface
     */
    resolveProfileRaw(requestParameters: ResolveProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileResolutionResponse>>;

    /**
     * Resolve a profile to generate a tailored catalog
     * Resolve profile
     */
    resolveProfile(requestParameters: ResolveProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileResolutionResponse>;

    /**
     * Search for profiles whose titles contain the specified text
     * @summary Search profiles by title
     * @param {string} title 
     * @param {string} [page] 
     * @param {string} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApiInterface
     */
    searchProfilesByTitleRaw(requestParameters: SearchProfilesByTitleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileListResponse>>;

    /**
     * Search for profiles whose titles contain the specified text
     * Search profiles by title
     */
    searchProfilesByTitle(requestParameters: SearchProfilesByTitleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileListResponse>;

    /**
     * Apply organizational values and modifications to tailor a profile
     * @summary Tailor profile
     * @param {string} id Profile UUID
     * @param {ProfileTailoringRequest} profileTailoringRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApiInterface
     */
    tailorProfileRaw(requestParameters: TailorProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileResponse>>;

    /**
     * Apply organizational values and modifications to tailor a profile
     * Tailor profile
     */
    tailorProfile(requestParameters: TailorProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileResponse>;

    /**
     * Update an existing OSCAL profile. When selectedControlIds or excludedControlIds are provided, they replace existing selections.
     * @summary Update profile
     * @param {string} id Profile UUID
     * @param {ProfileUpdateRequest} profileUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApiInterface
     */
    updateProfileRaw(requestParameters: UpdateProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileResponse>>;

    /**
     * Update an existing OSCAL profile. When selectedControlIds or excludedControlIds are provided, they replace existing selections.
     * Update profile
     */
    updateProfile(requestParameters: UpdateProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileResponse>;

    /**
     * Validate the structure and content of a profile
     * @summary Validate profile
     * @param {string} id Profile UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApiInterface
     */
    validateProfileRaw(requestParameters: ValidateProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>>;

    /**
     * Validate the structure and content of a profile
     * Validate profile
     */
    validateProfile(requestParameters: ValidateProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object>;

}

/**
 * 
 */
export class ProfileApi extends runtime.BaseAPI implements ProfileApiInterface {

    /**
     * Analyze the dependencies and imports of a profile
     * Analyze dependencies
     */
    async analyzeDependenciesRaw(requestParameters: AnalyzeDependenciesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling analyzeDependencies().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/profile/{id}/dependencies`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Analyze the dependencies and imports of a profile
     * Analyze dependencies
     */
    async analyzeDependencies(requestParameters: AnalyzeDependenciesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.analyzeDependenciesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new OSCAL profile. Ensures the tenant has the default catalog (from configuration service or file) so controls can be rendered.
     * Create profile
     */
    async createProfileRaw(requestParameters: CreateProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileResponse>> {
        if (requestParameters['profile'] == null) {
            throw new runtime.RequiredError(
                'profile',
                'Required parameter "profile" was null or undefined when calling createProfile().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/compliance/profile`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProfileToJSON(requestParameters['profile']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProfileResponseFromJSON(jsonValue));
    }

    /**
     * Create a new OSCAL profile. Ensures the tenant has the default catalog (from configuration service or file) so controls can be rendered.
     * Create profile
     */
    async createProfile(requestParameters: CreateProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileResponse> {
        const response = await this.createProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete an OSCAL profile
     * Delete profile
     */
    async deleteProfileRaw(requestParameters: DeleteProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteProfile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/profile/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete an OSCAL profile
     * Delete profile
     */
    async deleteProfile(requestParameters: DeleteProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteProfileRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieve a paginated list of all OSCAL profiles
     * Get all profiles
     */
    async getAllProfilesRaw(requestParameters: GetAllProfilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/profile`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProfileListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve a paginated list of all OSCAL profiles
     * Get all profiles
     */
    async getAllProfiles(requestParameters: GetAllProfilesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileListResponse> {
        const response = await this.getAllProfilesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve all organizational values defined for a profile
     * Get organizational values
     */
    async getOrganizationalValuesRaw(requestParameters: GetOrganizationalValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileTailoringRequest>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getOrganizationalValues().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/profile/{id}/organizational-values`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProfileTailoringRequestFromJSON(jsonValue));
    }

    /**
     * Retrieve all organizational values defined for a profile
     * Get organizational values
     */
    async getOrganizationalValues(requestParameters: GetOrganizationalValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileTailoringRequest> {
        const response = await this.getOrganizationalValuesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve a specific OSCAL profile by its UUID
     * Get profile by ID
     */
    async getProfileByIdRaw(requestParameters: GetProfileByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getProfileById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/profile/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProfileResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve a specific OSCAL profile by its UUID
     * Get profile by ID
     */
    async getProfileById(requestParameters: GetProfileByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileResponse> {
        const response = await this.getProfileByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve all profiles with a specific version
     * Get profiles by version
     */
    async getProfilesByVersionRaw(requestParameters: GetProfilesByVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileListResponse>> {
        if (requestParameters['version'] == null) {
            throw new runtime.RequiredError(
                'version',
                'Required parameter "version" was null or undefined when calling getProfilesByVersion().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/profile/version/{version}`;
        urlPath = urlPath.replace(`{${"version"}}`, encodeURIComponent(String(requestParameters['version'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProfileListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve all profiles with a specific version
     * Get profiles by version
     */
    async getProfilesByVersion(requestParameters: GetProfilesByVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileListResponse> {
        const response = await this.getProfilesByVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve the history of profile resolutions
     * Get resolution history
     */
    async getResolutionHistoryRaw(requestParameters: GetResolutionHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileResolutionResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getResolutionHistory().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/profile/{id}/resolution-history`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProfileResolutionResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve the history of profile resolutions
     * Get resolution history
     */
    async getResolutionHistory(requestParameters: GetResolutionHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileResolutionResponse> {
        const response = await this.getResolutionHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve the resolved catalog for a profile, if it exists
     * Get resolved catalog
     */
    async getResolvedCatalogRaw(requestParameters: GetResolvedCatalogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CatalogDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getResolvedCatalog().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/profile/{id}/resolved-catalog`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CatalogDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve the resolved catalog for a profile, if it exists
     * Get resolved catalog
     */
    async getResolvedCatalog(requestParameters: GetResolvedCatalogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CatalogDto> {
        const response = await this.getResolvedCatalogRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Resolve a profile to generate a tailored catalog
     * Resolve profile
     */
    async resolveProfileRaw(requestParameters: ResolveProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileResolutionResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling resolveProfile().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['resolvedBy'] != null) {
            queryParameters['resolvedBy'] = requestParameters['resolvedBy'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/profile/{id}/resolve`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProfileResolutionResponseFromJSON(jsonValue));
    }

    /**
     * Resolve a profile to generate a tailored catalog
     * Resolve profile
     */
    async resolveProfile(requestParameters: ResolveProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileResolutionResponse> {
        const response = await this.resolveProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for profiles whose titles contain the specified text
     * Search profiles by title
     */
    async searchProfilesByTitleRaw(requestParameters: SearchProfilesByTitleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileListResponse>> {
        if (requestParameters['title'] == null) {
            throw new runtime.RequiredError(
                'title',
                'Required parameter "title" was null or undefined when calling searchProfilesByTitle().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['title'] != null) {
            queryParameters['title'] = requestParameters['title'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/profile/search`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProfileListResponseFromJSON(jsonValue));
    }

    /**
     * Search for profiles whose titles contain the specified text
     * Search profiles by title
     */
    async searchProfilesByTitle(requestParameters: SearchProfilesByTitleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileListResponse> {
        const response = await this.searchProfilesByTitleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Apply organizational values and modifications to tailor a profile
     * Tailor profile
     */
    async tailorProfileRaw(requestParameters: TailorProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling tailorProfile().'
            );
        }

        if (requestParameters['profileTailoringRequest'] == null) {
            throw new runtime.RequiredError(
                'profileTailoringRequest',
                'Required parameter "profileTailoringRequest" was null or undefined when calling tailorProfile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/compliance/profile/{id}/tailor`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProfileTailoringRequestToJSON(requestParameters['profileTailoringRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProfileResponseFromJSON(jsonValue));
    }

    /**
     * Apply organizational values and modifications to tailor a profile
     * Tailor profile
     */
    async tailorProfile(requestParameters: TailorProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileResponse> {
        const response = await this.tailorProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing OSCAL profile. When selectedControlIds or excludedControlIds are provided, they replace existing selections.
     * Update profile
     */
    async updateProfileRaw(requestParameters: UpdateProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateProfile().'
            );
        }

        if (requestParameters['profileUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'profileUpdateRequest',
                'Required parameter "profileUpdateRequest" was null or undefined when calling updateProfile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/compliance/profile/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ProfileUpdateRequestToJSON(requestParameters['profileUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProfileResponseFromJSON(jsonValue));
    }

    /**
     * Update an existing OSCAL profile. When selectedControlIds or excludedControlIds are provided, they replace existing selections.
     * Update profile
     */
    async updateProfile(requestParameters: UpdateProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileResponse> {
        const response = await this.updateProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validate the structure and content of a profile
     * Validate profile
     */
    async validateProfileRaw(requestParameters: ValidateProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling validateProfile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/profile/{id}/validate`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Validate the structure and content of a profile
     * Validate profile
     */
    async validateProfile(requestParameters: ValidateProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.validateProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
